export default class Debug {
    static printToLog(type, message, data) {
        if (type === 'info') {
            data ? console.info('S&G_INF:', message, data) : console.info('S&G_INF:', message);
        } else if (type === 'error') {
            data ? console.error('S&G_ERR:', message, data) : console.error('S&G_ERR:', message);
        } else {
            data ? console.log('S&G_LOG:', message, data) : console.log('S&G_LOG:', message);
        }
    };
}